import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseAvailableProduct } from '@api/models/responseAvailableProduct';
import { Endpoints } from '@api/constants/endpoints.constants';
import { map, pluck } from 'rxjs/operators';
import { SalesforceResponse, Cnogroupcnocnae, ImpositionCondition, FormDataResponse } from '@api/models';
import { AddressResponseData } from '@api/models/addressResponseData';
import { AccountService } from '../account/account.service';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService {
  constructor(private http: HttpClient, private accountService: AccountService,) {}

  getProducts(email?: string) {
    const params = email && { email };
    return this.http
      .get<ResponseAvailableProduct>(Endpoints.products, { params })
      .pipe(map(({ data }) => data[0]));
  }


  getFormData() {
    return this.http
      .get<FormDataResponse>(Endpoints.formdata)
      .pipe(map(({ data }) => data[0]));
  }

  getEmploymentStatus() {
    return this.http
      .get<SalesforceResponse<Cnogroupcnocnae>>(Endpoints.employmentStatus)
      .pipe(pluck('data'));
  }

  getCNO() {
    return this.http.get<SalesforceResponse<Cnogroupcnocnae>>(Endpoints.cno).pipe(pluck('data'));
  }

  getCNAE() {
    return this.http.get<SalesforceResponse<Cnogroupcnocnae>>(Endpoints.cnae).pipe(pluck('data'));
  }

  getLocation(postalcode: string) {
    const params = { postalcode };
    return this.http
      .get<SalesforceResponse<AddressResponseData>>(Endpoints.address, { params })
      .pipe(
        map((response) => {
          return response.data[0].availableLocation;
        })
      );
  }

  getImpositionConditions() {
    const clientType = this.accountService.currentCustomer.DatosPersonales.clientType;
    const params = new HttpParams().set('clientType', clientType);
    return this.http
      .get<SalesforceResponse<ImpositionCondition>>(Endpoints.impositionCondition, { params })
      .pipe(pluck('data'));
  }
}
